export const navBarItems = [
    {name: "Home", url: "/"},
    {name: "About", url: "/#about"},
    {name: "FAQ", url: "/#faq"},
]

export const heroSections = {
    title: {
        centreTagline: {top: "The great memories of school", main: "MEMORY LANE 2K25", bottom: "Nostalgia Feeling"},
        subTitle: "An independently organized event by the DPS Siliguri Alumni, Batches of 2008 and 2010",
        footer: "Hiland Hotel, Siliguri, 10th May 2025"
    },
    backgroundImage: "",
    buttons: [
        // {type: "primary", name: "Register Now", url: "/register"},
        {type: "secondary", name: "Read more", url: "/#about"},
    ]
}

export const aboutSection = {
    title: {main: "ABOUT THE EVENT"},
    mobile: [`
       Step into cherished memories at our Alumni Meetup, where past bonds come alive. Reconnect with classmates, 
           reminisce about school days, and celebrate personal milestones. With fun activities and a warm atmosphere, 
        this event blends nostalgia with excitement. Join us for a day of joy, camaraderie, and unforgettable moments!`
    ],
    desktop: [
        `Step into the cherished moments of the past with our Alumni Meetup, a celebration of the bonds and memories
        forged during school days. This event is a journey down Memory Lane, where the laughter, friendships, and 
        stories of the good old days come alive.`,
        `Reconnect with classmates, reminisce about shared experiences, and celebrate the milestones you’ve achieved 
        since those formative years. Whether it's revisiting tales from the classroom or celebrating the achievements 
        of your batch, this meetup is an opportunity to relive the great memories of school and create new ones.`,
        `With a thoughtfully curated itinerary, engaging activities, and a warm atmosphere, this event promises a 
        perfect blend of nostalgia and excitement. Take your first steps towards rekindling old connections and 
        making this gathering an unforgettable experience.`,
        `Join us for a day filled with joy, camaraderie, and heartfelt moments!`
    ]
}

export const memoryLaneExpSection = {
    title: {main: "MEMORY LANE EXPERIENCE"},
    cards: [
        {
            title: "Meet and Greet",
            content: "Introductions, casual conversations, icebreakers, warm welcomes, handshakes, first impressions."
        }, {
            title: "Fun and Frolic",
            content: "Team challenges, friendly competition, laughter, creative activities, bonding moments"
        }, {
            title: "Party till you last",
            content: "Cocktails, music, dancing, laughter, energy, celebration, friends, fun, party vibes."
        }
    ]
}

export const locationsSection = {
    title: "LOCATION",
    hotelName: "Hiland Hotel",
    hotelAddress: "PRM, Sevoke Rd, Ward 43, Dasrath Pally, Bhanu Nagar, Siliguri, West Bengal 734001",
    roomName: "Lime Leaf",
    roomAddress: "1st Floor",
    image: ""
}

export const midBanner = {
    image: "",
    tagline: {
        title: "Delhi Public School, Siliguri",
        subTitle: `-"service before self"`
    }
}

export const itinerarySection = {
    title: {main: "ITINERARY"},
    items: [
        "5:30 PM: Roll call! Grab your name tags and coupons – your pass to all the fun. Say hi, and get ready to dive in!",
        "6:00 pm -7:00 pm : Let the fun begin! Kick things off with a welcome speech by the OG crew, followed by ice-breaking games like musical chairs, housie, and trivia. Meet, greet, and laugh your way into the evening!",
        "7pm onwards:  Mingle, reconnect, and vote for quirky awards like “Best Dressed” and “Most Likely to Still Get Detention.” The award ceremony will keep the laughs going, followed by a foodie fiesta to end the night on a delicious note!",
    ]
}

export const faqSection = {
    title: {main: "FAQ"},
    description: "No, but we are planning to visit school next day for photo session. Timings will be provided after " +
        "confirmation from school",

    items: [
        {
            q: "Is the school jumping on the nostalgia bandwagon with us?",
            a: "This is a self-funded event, so the school’s involvement is optional. However, we’re planning a nostalgic visit to the school the next day—pending their approval, of course!"
        },
        {
            q: "When should we show up to avoid being fashionably late?",
            a: "We'd appreciate it if you could arrive by 5pm. The earlier, the better!"
        },
        {
            q: "Are we getting a cozy spot to crash for the event?",
            a: "Staying overnight is optional. If you need accommodation, please mark ‘Accommodation Required’ while registering and select the option that suits you best. We have 30 rooms available, allocated on a first-come, first-served basis. Both single and double occupancy options are available. The stay covers check-in on 10th May 2025 and check-out on 11th May 2025."
        },
        {
            q: "Will a chariot (or cab) whisk us away from NJP or Bagdogra? ",
            a: "Getting to the hotel or event is a solo adventure—no chariot service this time! You can team up with friends, grab one of the amazing cab services in Siliguri, or go rogue and find your own way! The choice is yours."
        },
        {
            q: "Who’s our go-to person when we’re lost ?",
            a: "Akul Saurav: +91-9968336459, Paridhi Gupta +91-9971295648, Sourabh Dutta: +91-9632321371,  Arka Sarkar: +91-7679172285"
        },
        {
            q: "Can I bring a plus one, or is it a solo mission?",
            a: "Sorry, it’s a solo adventure—just you and your old pals this time!"
        },
        {
            q: "What’s the dress code for the event?",
            a: "We’ll spill the details as we get closer—stay tuned for the fashion reveal!"
        },
        {
            q: "Is registration mandatory?",
            a: "You must register in advance—this helps us plan the budget and avoid last-minute chaos. Trust us, showing up unregistered will throw the team into a total pickle! So, register and show up like a legend!"
        },

    ]
}